<template>
    <div class="form">
        <h4 class="step-title">
            Is the vehicle leased or owned?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <button-list v-bind:items="ownershipTypes" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "VehicleOwnershipType",
        components: {
            ButtonList
        },
        data: function() {
            return {
                ownershipTypes: [
                    { text: "Leased", value: "Lease" },
                    { text: "Owned", value: "Own" }
                ]
            }
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            complete: function(vehicleOwnershipType) {
                this.vehicle.ownershipType = vehicleOwnershipType;
                this.$emit("complete", this.$options.name, this.vehicle.ownershipType);
            }
        }
    }
</script>
